import { Suspense, lazy } from 'react';
import Hero from '../components/Hero';
import FeatureStrip from '../components/FeatureStrip';
import Intro from '../components/Intro';

const Services = lazy(() => import('../components/Services'));
const PrintAnywhere = lazy(() => import('../components/PrintAnywhere'));
const Payments = lazy(() => import('../components/Payments'));
const ClassLeading = lazy(() => import('../components/ClassLeading'));
const SupportBanner = lazy(() => import('../components/SupportBanner'));
const WhyChooseUs = lazy(() => import('../components/WhyChooseUs'));

function BelowFold() {
  return (
    <>
      <Services />
      <PrintAnywhere />
      <Payments />
      <ClassLeading />
      <SupportBanner />
      <WhyChooseUs />
    </>
  );
}

export default function HomePage() {
  return (
    <>
      <Hero />
      <FeatureStrip />
      <Intro />
      <Suspense fallback={null}>
        <BelowFold />
      </Suspense>
    </>
  );
}
